import { CardContent, Grid, Typography } from '@mui/material';

import { Card } from '@occc/ui-design-system';

type Props = {
  title?: string;
  amount: number;
};

export const PointChangeViewFooter = (props: Props) => {
  const { title, amount } = props;

  return (
    <Card
      sx={(theme) => ({
        marginTop: theme.spacing(1),
      })}
    >
      <CardContent>
        <Grid container spacing={2} justifyContent='space-between'>
          <Grid item>
            <Typography fontWeight='bold'>{title}</Typography>
          </Grid>
          <Grid item textAlign='right'>
            <Typography fontWeight='bold'>{amount}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
